import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { channels, siteInfo } from '@/mocks/brand';
import useScrollAnimation from '@/hooks/useScrollAnimation';

const HERO_VIDEO_URL = 'https://public.readdy.ai/ai/video_res/01a0ec0c-b9be-7250-82dc-183380ea113f.mp4';

function StoresHero() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.05 });
  return (
    <section
      ref={ref}
      className="relative min-h-[100svh] flex flex-col items-center justify-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <video
          src={HERO_VIDEO_URL}
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div
        className={`relative z-10 flex flex-col items-center text-center px-6 md:px-10 w-full max-w-[720px] transition-all duration-700 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <span className="inline-block text-xs text-background-50/60 uppercase tracking-widest mb-4">
          合作通路
        </span>
        <h1
          className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4"
          style={{ textShadow: '0 2px 12px rgba(0,0,0,0.50), 0 1px 4px rgba(0,0,0,0.30)' }}
        >
          合作通路
        </h1>
        <p
          className="text-background-50/85 text-sm md:text-base leading-relaxed max-w-[560px] text-balance"
          style={{ textShadow: '0 1px 6px rgba(0,0,0,0.45)' }}
        >
          讀者可透過以下通路搜尋沐燁文化 Moya 正式出版書籍。不同平台上架狀態可能有所不同，請以各平台頁面為準。
        </p>
      </div>
    </section>
  );
}

function StoresList() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.05 });
  return (
    <section
      ref={ref}
      className="relative min-h-[100svh] flex flex-col items-center justify-center bg-background-100 overflow-hidden py-20 md:py-24"
    >
      <div
        className={`relative z-10 flex flex-col items-center px-6 md:px-10 w-full max-w-[960px] transition-all duration-700 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 w-full">
          {channels.map((ch) => (
            <div
              key={ch.id}
              className="flex flex-col sm:flex-row items-start gap-4 p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-xl h-full"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 shrink-0">
                <i className={`${ch.icon} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h2 className="font-heading text-base font-semibold text-foreground-950 mb-1.5">
                  {ch.title}
                </h2>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                  {ch.description}
                </p>
                <a
                  href={ch.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer"
                >
                  前往 {ch.name}
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-external-link-line text-xs"></i>
                  </span>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 p-6 md:p-8 bg-primary-50 border border-primary-200/60 rounded-xl w-full">
          <h2 className="font-heading text-base font-semibold text-primary-800 mb-3">
            關於購書
          </h2>
          <p className="text-sm text-primary-700/80 leading-relaxed">
            不同平台的上架狀態、書籍格式與銷售方式可能不同，請以各平台頁面為準。若有特殊訂購需求，歡迎透過崧博出版官方網站（sonbook.net）聯繫。
          </p>
        </div>

        <div className="mt-8">
          <a
            href={siteInfo.catalogUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            前往書籍資料庫
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line text-xs"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default function ChannelsPage() {
  return (
    <>
      <Navbar />
      <main>
        <StoresHero />
        <StoresList />
      </main>
      <Footer />
    </>
  );
}